import { observer } from "mobx-react-lite";
import { Button } from "antd-mobile";
import useNavigation from "../../hooks/useNavigation";
import PageWrap from "../components/PageWrap";
import PageHeader from "../components/PageHeader";

const PhoneBindingSuccess = () => {
  const { navigate } = useNavigation();
  return (
    <PageWrap>
      <PageHeader title="绑定成功" />
      <div style={{ textAlign: "center", padding: 40 }}>
        <div style={{ fontSize: 20, marginBottom: 20 }}>手机绑定成功</div>
        <Button color="primary" onClick={() => navigate("Wallet")}>返回钱包</Button>
      </div>
    </PageWrap>
  );
};
export default observer(PhoneBindingSuccess);
